// src/components/webBooking/MembershipPlans.js
import React, { useEffect, useState } from "react";
import SalonService from "../../services/SalonService";
import LoadingIndicator from "../loadingIndicator/LoadingIndicator";
import "./MembershipPlans.css";
import { useSalon } from "../../context/SalonContext";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "../../../src/style.css";
import NoSalonSelected from "../salon/NoSalonSelected";

const MembershipPlans = () => {
    const { accessToken, salonUuid, customerId, mobileNumber } = useSalon();
    const [loading, setLoading] = useState(true);
    const [plans, setPlans] = useState([]);
    const [loadingPlanId, setLoadingPlanId] = useState(null);


    useEffect(() => {
        const fetchPlans = async () => {
            try {
                let mySalonUuid = salonUuid ? salonUuid : localStorage.getItem("SALON_UUID");
                if (mySalonUuid) {
                    const response = await SalonService.getSalonMembershipPlans(mySalonUuid);
                    //console.log('response.data ::', response.data);
                    setPlans(response.data?.membershipPlans || []);
                } else if (!mySalonUuid) {
                    return <NoSalonSelected />;
                }

            } catch (err) {
                console.error("Error fetching membership plans:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
    }, [accessToken, salonUuid]);

    const handlePurchase = async (planId) => {
        try {
            if (!salonUuid) {
                toast.error("Salon details not found.");
                return;
            }

            setLoadingPlanId(planId); // start loading for this plan

            const data = { planId, customerId, mobileNumber }
            const response = await SalonService.purchaseMembership(
                salonUuid,
                data
            );

            if (response.status === 200) {
                toast.success("🎉 Membership purchased successfully!");
                // You can also refresh membership status here
            }
        } catch (error) {
            console.error("Purchase failed:", error);
            toast.error(
                error.response?.data?.message || "❌ Failed to purchase membership. Try again."
            );
        } finally {
            setLoadingPlanId(null); // stop loading
        }
    };

    return (
        <div className="app-container">
            <div className="app-sub-container">
                <h2 className="header-title">Membership Plans</h2>
                {loading && <LoadingIndicator />}
                {!loading && plans.length === 0 && (
                    <div className="no-plans">No membership plans available.</div>
                )}

                <div className="plans-list">
                    {plans.map((plan) => {
                        const isExpiryPlan = plan.validityType?.toLowerCase() === "expirydate" && plan.expiryDate;
                        let isExpired = false;
                        let isExpiringSoon = false;
                        let validityText = "";

                        if (isExpiryPlan) {
                            const expiryDate = new Date(plan.expiryDate);
                            const today = new Date();
                            const diffDays = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));

                            if (diffDays < 0) {
                                isExpired = true;
                                validityText = `Expired on ${expiryDate.toLocaleDateString()}`;
                            } else if (diffDays <= 7) {
                                isExpiringSoon = true;
                                validityText = `Until ${expiryDate.toLocaleDateString()} (Expires Soon)`;
                            } else {
                                validityText = `Until ${expiryDate.toLocaleDateString()}`;
                            }
                        } else {
                            validityText = `${plan.durationInDays} days`;
                        }

                        return (
                            <div
                                key={plan.id}
                                className={`plan-card ${isExpired ? "expired-plan" : ""}`}
                            >
                                {isExpired && <div className="expired-badge">Expired</div>}
                                {!isExpired && <div className="recommended-badge">Recommended</div>}

                                <h3>{plan.name}</h3>
                                <p>{plan.description}</p>
                                <p><strong>Price:</strong> ₹{plan.price}</p>
                                <p>
                                    <strong>Validity:</strong>{" "}
                                    <span
                                        className={
                                            isExpired
                                                ? "expired-text"
                                                : isExpiringSoon
                                                    ? "expires-soon"
                                                    : ""
                                        }
                                    >
                                        {validityText}
                                    </span>
                                </p>

                                <div className="plan-benefits">
                                    <h4>Benefits:</h4>
                                    <ul>
                                        {plan.benefits.map((benefit, idx) => {
                                            let highlighted = benefit
                                                .replace(/(free)/gi, '<span class="highlight-free">$1</span>')
                                                .replace(/(discount)/gi, '<span class="highlight-discount">$1</span>');

                                            let icon = "✅";
                                            if (/free/i.test(benefit)) icon = "🎁";
                                            else if (/discount/i.test(benefit)) icon = "💸";

                                            return (
                                                <li key={idx}>
                                                    <span className="benefit-icon">{icon}</span>
                                                    <span
                                                        className="benefit-text"
                                                        dangerouslySetInnerHTML={{ __html: highlighted }}
                                                    />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>

                                {!isExpired && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => handlePurchase(plan.id)}
                                        disabled={loadingPlanId === plan.id}
                                    >
                                        {loadingPlanId === plan.id ? (
                                            <>
                                                <FaSpinner className="icon-spin" /> Processing…
                                            </>
                                        ) : (
                                            "Buy Now"
                                        )}
                                    </button>
                                )}
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
};


export default MembershipPlans;
